import { render, staticRenderFns } from "./InventoryRichModal.vue?vue&type=template&id=71d5526c"
import script from "./InventoryRichModal.vue?vue&type=script&lang=js"
export * from "./InventoryRichModal.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d5526c')) {
      api.createRecord('71d5526c', component.options)
    } else {
      api.reload('71d5526c', component.options)
    }
    module.hot.accept("./InventoryRichModal.vue?vue&type=template&id=71d5526c", function () {
      api.rerender('71d5526c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/QuestionnaireSystem/components/CreateQuesRule/components/InventoryRichModal.vue"
export default component.exports